//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { mapActions } from "vuex";

export default {
    name: "ExportPanel",
    components: {
        AQButton,
        AQTooltip
    },
    props: {
        columns: { type: Array, default: () => [] },
        entityCode: { type: String, default: "" }
    },
    data() {
        return {
            panelOpen: false,
            selectedColumns: []
        };
    },

    computed: {
        options() {
            const result = this.columns.reduce((acc, { label, code, name }) => {
                if (name === "deleteColumn") {
                    return acc;
                }
                acc.push({
                    label,
                    value: code
                });
                return acc;
            }, []);
            return result;
        }
    },
    watch: {
        options: {
            handler(newVal) {
                this.selectedColumns = newVal.map(({ value }) => value);
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions("dataStore", ["exportTable"]),
        cancel() {
            this.$emit("closePanel");
        },
        exportData() {
            const selectedSet = new Set(this.selectedColumns);
            const payload = {
                entityCode: this.entityCode,
                columns: this.columns.reduce(
                    (acc, { code }) => {
                        if (selectedSet.has(code)) {
                            acc.push({ code });
                        }
                        return acc;
                    }, []
                )
            };
            this.exportTable(payload).then(() => {
                this.$toast.showNotify({
                    type: "info",
                    message: this.$t("dataTable.exportNotification"),
                    hasClose: false
                });
            });
            this.cancel();
        }
    }
};
